// SignupDisabled Component
//
// Rendered by `SignupView` when the public
// `GET /api/v1/frictionless/website/signup-availability` probe (or a 400
// "disabled" response from the submit endpoint) reports that website
// signups are currently turned off via the PostHog feature flag.
//
// Shown instead of `SignupForm` so users don't fill in personal details
// only to be rejected by `POST /signup` with a 400.

import React from 'react';
import { InformationCircleIcon } from '@heroicons/react/24/outline';

const SignupDisabled: React.FC = () => {
  return (
    <div className="text-center">
      {/*
       * Icon styling mirrors SignupSuccess (h-12 w-12 circle + h-6 w-6
       * icon) for visual consistency across the /signup page chrome, but
       * uses informational blue rather than success green to signal an
       * intentional, non-error "unavailable" state.
       */}
      <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-blue-100">
        <InformationCircleIcon className="h-6 w-6 text-blue-600" aria-hidden="true" />
      </div>
      <h3 className="mt-4 text-lg font-medium text-gray-900">Sign-ups are currently unavailable</h3>
      <p className="mt-2 text-sm text-gray-600">
        We&apos;re not accepting new DataOps.live website sign-ups right now. Please check back soon, or get in touch
        with our team if you need access urgently.
      </p>
      <div className="mt-6 bg-blue-50 border border-blue-200 rounded-lg p-4 text-left">
        <p className="text-sm text-blue-800">
          Already have an account?{' '}
          <a href="/login" className="font-medium text-blue-700 hover:text-blue-900 underline">
            Sign in here
          </a>
          .
        </p>
      </div>
    </div>
  );
};

export default SignupDisabled;
